import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Payment',
      description: 'PCI DSS compliant'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Merchant',
      description: 'Trusted by 50K+ customers'
    }
  ];

  return (
    <div className="bg-success/5 border border-success/20 rounded-lg p-4">
      <div className="flex items-center space-x-2 mb-3">
        <Icon name="ShieldCheck" size={20} className="text-success" />
        <h3 className="font-medium text-success">Your Purchase is Protected</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Icon name={feature?.icon} size={16} className="text-success flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-foreground">{feature?.title}</p>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityIndicators;